import { useState } from 'react';

/** Device class, not viewport width: desktop zoom never selects the mobile UI. */
export function isMobileDevice(): boolean {
  if (typeof navigator === 'undefined') return false;
  const hints = navigator as Navigator & { userAgentData?: { mobile?: boolean } };
  return hints.userAgentData?.mobile === true
    || /Android|iPhone|iPad|iPod/i.test(navigator.userAgent)
    || (/Macintosh/i.test(navigator.userAgent) && navigator.maxTouchPoints > 1);
}

export function useMobileDevice(): boolean { return useState(isMobileDevice)[0]; }

/** Physical display pixels; captured on an explicit render, never persisted on resize. */
export function mobileRenderSize(): { width: number; height: number } {
  const ratio = window.devicePixelRatio || 1;
  const portrait = window.innerHeight >= window.innerWidth;
  const small = Math.min(screen.width, screen.height);
  const large = Math.max(screen.width, screen.height);
  return {
    width: Math.max(16, Math.round((portrait ? small : large) * ratio)),
    height: Math.max(16, Math.round((portrait ? large : small) * ratio)),
  };
}
